export { default } from './data-error';
